<script>

export default {
  name: "TheStudentScholarshipScoreCard",

  props: {
    personScores: Object,
    isPersonScoresPresent: {
      type: Boolean,
      default: false,
    }
  },

  mount() {
  },

  computed: {

    educationalScore() {
      return this.personScores?.sum_score_education || 0.0;
    },

    researchScore() {
      return this.personScores?.sum_score_research || 0.0;
    },

    socialActivityScore() {
      return this.personScores?.sum_score_social_activity || 0.0;
    },

    culturalCreativeScore() {
      return this.personScores?.sum_score_cultural_creative || 0.0;
    },

    sportScore() {
      return this.personScores?.sum_score_sports || 0.0;
    },

    sumScore() {
      return this.personScores?.sum_score || 0.0;
    },

  },
}
</script>

<template>
  <v-card
    outlined
    flat
    class="rounded-xl"
  >
    <v-card-title class="text-center title-wrap">
      Баллы заявления для конкурса в ПГАС
      <v-icon right>
        fa-calculator
      </v-icon>
    </v-card-title>

    <v-divider/>

    <template v-if="isPersonScoresPresent">
      <v-card-text class="pa-0 pb-2">
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{educationalScore}} бал.</v-list-item-title>
              <v-list-item-subtitle>Учебная <v-icon x-small>fa-book</v-icon></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>{{researchScore}} бал.</v-list-item-title>
              <v-list-item-subtitle>Научная <v-icon x-small>fa-graduation-cap</v-icon></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>{{culturalCreativeScore}} бал.</v-list-item-title>
              <v-list-item-subtitle>Культурная <v-icon x-small>fa-paint-brush</v-icon> </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{socialActivityScore}} бал.</v-list-item-title>
              <v-list-item-subtitle>Общественная  <v-icon x-small>fa-users</v-icon>  </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>{{sportScore}} бал.</v-list-item-title>
              <v-list-item-subtitle>Спортивная <v-icon x-small>fa-child</v-icon>  </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>{{sumScore}} бал.</v-list-item-title>
              <v-list-item-subtitle class="font-weight-bold">Общий Итог <v-icon x-small>fa-circle</v-icon></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-card-text>
    </template>



    <template v-else>
      <v-card-text class="text-center text-body-1">
        Обратите внимание, что у вас в настоящее время <span class="text-h6"> нет заявления для участия </span> в комиссии ПГАС.
        Чтобы создать заявление, перейдите, пожалуйста, в раздел <span class="text-h6"> "ПОРТФОЛИО" </span>,
        выберите вкладку <span class="text-h6"> "ЗАЯВЛЕНИЕ ПГАС" </span> и заполните необходимую информацию для участия в конкурсе.
      </v-card-text>

      <v-card-text class="text-center text-body-1">
        <span class="text-h6">Период заполнения заявления </span>

        <p class="ma-0"><span class="text-h6">c 1-го до 10-го февраля </span></p>
        <p class="ma-0"><span class="text-h6">c 1-го до 10-го июля </span></p>
      </v-card-text>

      <v-card-text class="text-center text-body-1">
        Если вы создали заявление и оно <span class="text-h6"> не отображается </span>, свяжитесь с отделом ЦЦТиТО для технической поддержки.
      </v-card-text>
    </template>

  </v-card>
</template>

<style scoped>
.title-wrap {
  word-break: keep-all;
}

</style>